.fp-staff-layout--body--content-sidebar(v-if='isSidebarOpened' data-test='sidebar' :class='{"-closed": isClosing}')
  .fp-staff-layout--body--content-sidebar--header(data-test='title') {{ sidebar.title }}
  .fp-staff-layout--body--content-sidebar--close(v-if='isClosable' @click='closeSidebar' data-test='close')
    button.fp-icon.fp-glyph-close.-color-shade-500.-s16.-pointer
  component(data-test='sidebar' :is='sidebar.component' :options='sidebar.options')
